
export enum ContractState {
    new = 'new',
    confirmed = 'confirmed',
    dispatched = 'dispatched',
    returned = 'returned',
    prepared = 'prepared',
    picked = 'picked',
    handed = 'handed',
    waitingAccept = 'waitingAccept',
    received = 'received',
    in_dispatch = 'in_dispatch',
    canceled = 'canceled',
}



// WEBPACK FOOTER //
// /app/src/model/Entities/ContractState.ts